<div class="flex flex-column gap-2">
  <div
    class="flex align-items-center justify-content-between cursor-pointer hover:surface-100 border-round transition-all transition-duration-150 p-2"
    (click)="toggleExpanded.emit()">
    <div class="flex align-items-center gap-2">
      <div (click)="$event.stopPropagation()">
        <ng-content select="[left]"></ng-content>
      </div>

      <div class="flex align-items-center gap-2">
        @if (poi.icon) {
          <app-svg-icon [key]="poi.icon"></app-svg-icon>
        }
        <span>{{ poi.name }}</span>
      </div>
    </div>

    <div class="flex align-items-center gap-2 ml-auto">
      <div (click)="$event.stopPropagation()">
        <ng-content select="[right]"></ng-content>
      </div>

      <p-button
        [icon]="expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
        [text]="true"
        [rounded]="true"
        styleClass="p-button-xs"
        (click)="toggleExpanded.emit(); $event.stopPropagation()" />
    </div>
  </div>

  @if (expanded) {
    <div class="ml-4 mt-2">
      <ng-content select="[content]"></ng-content>
    </div>
  }
</div>
